import _ from 'lodash';
import { CURRENCIES } from 'src/config';

export const formatCurrency = (currency) => (_.has(CURRENCIES, currency) ? CURRENCIES[currency] : currency);
